
import MoneySend from "../../../assets/filled/MoneySend.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoneySendIcon({ className, dataTestid = "MoneySendIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MoneySend data-testid={dataTestid} className={classes} {...rest} />
  );
}
